module.exports = __webpack_public_path__ + "static/media/nature.d8da6e28.jpg";